import { render, staticRenderFns } from "./OrdersSidebar.vue?vue&type=template&id=18c452c0&scoped=true&"
import script from "./OrdersSidebar.vue?vue&type=script&lang=js&"
export * from "./OrdersSidebar.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=18c452c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c452c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18c452c0')) {
      api.createRecord('18c452c0', component.options)
    } else {
      api.reload('18c452c0', component.options)
    }
    module.hot.accept("./OrdersSidebar.vue?vue&type=template&id=18c452c0&scoped=true&", function () {
      api.rerender('18c452c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/pages/orders/OrdersSidebar.vue"
export default component.exports